import React, { Component } from "react";
import {URL_TOOL_UPT} from "../../const";
const CATEGORY = "1";

export default class ButtonBackUpt extends Component {
  render() {
    let {paramUrl} = this.props;
    let urlTool = new URL(URL_TOOL_UPT);
    // urlTool = new URL(urlTool + window.location.search);
    // urlTool.searchParams.append('goto_category', CATEGORY);
    if(paramUrl.sessionUpT && paramUrl.loginType){
      urlTool = urlTool + '?session=' + paramUrl.sessionUpT + '&login_type='+paramUrl.loginType+ '&goto_category=' + CATEGORY;
    }else{
      urlTool = urlTool + '?goto_category=' + CATEGORY
    }
    return (
      <a className="btn_stock substrate-upt" href={urlTool}>
        <span className="substrateBg"></span>
        <span>デザインツールに戻る</span>
      </a>
    );
  }
}
